import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HttpConfigService {
  domain: string;
  apiPath: string;
  constructor() {
    // this.domain  = 'http://localhost';
    this.domain  = '';
    this.apiPath = `${this.domain}/fspersonnel/api/`;
   }
}
